module.exports = __webpack_public_path__ + "img/infiniti-Used.b7c7b57a.png";